import { Button, Modal, Form } from "antd-mobile";
import React, { useState, useContext } from "react";
import { InputGroup } from "react-bootstrap";
 import AttendanceTypeSelectView from "./attendanceTypeSelectView";
import { Card } from "react-bootstrap";
import { jsonToQuery, lowerCase, momentDate, upperCase } from "../../utils";
import PsContext from "../../context";

const AttendanceType = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  const paramsField = (fieldName) => props?.dataParams?.[fieldName] || "";


  //console.log('test',props);

  const handleButtonClick = () => {
    Modal.show({
      title: "Select Attendance",
      content: <AttendanceTypeSelectView {...props} />,
      showCloseButton: true,
    });
  };

  return (
    <>
      {props.dataSource && props.dataSource.length > 0 ? (
        <>
          Service Organization Attendance
          <InputGroup>
            <div className="fs-6 form-control form-control-sm fw-bold uppercase">
          
              {props.dataSource[0].srv_org_name} > {props.dataSource[0].date}
            </div>
            <InputGroup.Text
              className="cursor-pointer"
              onClick={(e) => handleButtonClick()}
            >
              <i className="fa-solid fa-edit"></i>
            </InputGroup.Text>
          </InputGroup>
        </>
      ) : (
        <Button
          fille="outline"
          block
          size="middle"
          onClick={(e) => handleButtonClick()}
        >
          <i className="me-2 fa-regular fa-clipboard"></i> Select Service Organization Attendance
        </Button>
      )}
    </>
  );
};
export default AttendanceType;
